/** H5 订单类型公共配置。保持后端类型值；贸易、供应链可用，保理放账禁用。 */
const ORDER_TYPES = Object.freeze([
  { value: 10, name: "贸易", disabled: false },
  { value: 20, name: "供应链", disabled: false },
  { value: 30, name: "保理放账", disabled: true },
].map(item => Object.freeze({ ...item, label: item.name })));
const ORDER_TYPE_NAMES = Object.freeze(
  ORDER_TYPES.reduce((result, item) => { result[item.value] = item.name; return result; }, {})
);
// 兼容旧草稿的展示名称；只转换已知枚举，不给未知值猜默认类型。
const normalizeOrderType = (value) => {
  const text = typeof value === "string" ? value.trim() : value;
  const option = ORDER_TYPES.find(item => item.value === text || String(item.value) === text || item.name === text);
  return option ? option.value : value;
};
// 仅适配合同表单的 orderType，不能混用 mall_order.type 或 type_business。
const normalizeContractOrderPayload = (data) => ({
  ...data,
  ...(Object.prototype.hasOwnProperty.call(data, "orderType") ? { orderType: normalizeOrderType(data.orderType) } : {}),
  ...(data.form ? { form: { ...data.form, orderType: normalizeOrderType(data.form.orderType) } } : {}),
});
// 固定三语显示仅由可选翻译函数处理，原类型值及默认中文公共契约不变。
const getOrderTypeName = (value, fallback = "", translate) => {
  const keys = { 10: "transactionDetail.trade", 20: "transactionDetail.supplyChain", 30: "transactionDetail.factoring" };
  return typeof translate === "function" && keys[Number(value)] ? translate(keys[Number(value)]) : ORDER_TYPE_NAMES[Number(value)] || fallback;
};
// 旧合同页使用字符串页签，保留标识并继承公共禁用状态。
const CONTRACT_ORDER_TABS = Object.freeze(ORDER_TYPES.map((item, index) => Object.freeze({
  ...item, title: item.name, name: ["agentPay", "agentPurchase", "factoring"][index],
})));
export { ORDER_TYPES, ORDER_TYPE_NAMES, CONTRACT_ORDER_TABS, getOrderTypeName, normalizeOrderType, normalizeContractOrderPayload };
